export const ADD_SAVED_PRODUCT = "ADD_SAVED_PRODUCT";
export const UPDATE_SAVED_PRODUCT = "UPDATE_SAVED_PRODUCT";
export const REMOVE_SAVED_PRODUCT = "REMOVE_SAVED_PRODUCT";
export const RECEIVE_SAVED_ITEMS_SUMMARY = "RECEIVE_SAVED_ITEMS_SUMMARY";
export const REMOVE_FROM_SUMMARY = "REMOVE_FROM_SUMMARY";
